import Register from "views/auth/Register.js";
import Login from "views/auth/Login.js";

import EntityList from "views/EntityList.jsx";
import RepaymentSchedule from "views/Repayment/RepaymentSchedule.jsx";
import Dashboard from "views/Dashboard.js";
import PaymentReco from "views/PaymentReco.jsx";
import LoanReco from "views/LoanReco.jsx";
import Training from "views/Training.jsx";
import PortfolioReport from "views/Reporting/PortfolioReport.jsx";
import EnrichmentRetry from "views/EnrichmentRetry.jsx";
import PersonalLoanBulkUpload from "views/PersonalLoanBulkUpload.jsx";
import { URL as API_URL } from "./api";
import LeadList from "views/LeadList.js";
import Privilege from "views/Privilage/Privilege.js";
import UserManagement from "views/AdminPanel/UserManagement.js";
import BrePanel from "views/BrePanel/Index";
import PayOutRequest from "views/PayOutRequest/Payout.js";
import getPrivilegeList from "./PrivilegeList";

 import LspBalance from "views/TopRightBar/LspBalance.js";

 
// import privilegeList from "./PrivilegeList";
import LspProvidedJson from "views/Customer/LspProvidedJson";
import CustomerDetail from "views/Details/Index";
import CustomerDocuments from "views/Documents/CustomerDocuments.js";
import Loans from "views/Loans/Loans";
import LeadCredit from "views/Details/LeadCredit";
import Analytics from "views/Analytics/Analytics";
import Credit from "views/Credit/Credit";
import Foir from "views/Customer/Foir.js";
import Installment from "views/Installment/Installment.js";
import Comments from "views/Comments/Comments";
import Communication from "views/Customer/Communication.js";
import Legal from "views/Customer/Legal";
import Template from "views/TopRightBar/Template.js";
import LSPList from "views/TopRightBar/LSPList.js";
import Reporting from "views/Reporting/Reporting";
import MerchantReports from "views/Reporting/MerchantReports.jsx";
import LoanDocuments from "views/Reporting/LoanDocuments.jsx";
import UpdateLspList from "views/TopRightBar/UpdateLspList";
import FintechWallet from "views/FintechWallet.js";
import LoanAgreement from "views/Agreement/LoanAgreement.jsx";
import OverdueReporting from "views/Reporting/OverdueReporting";

import Webhook from "views/Credit/webhook";
import MasterScroll from "views/Details/MasterScroll.js";
import PaymentLead from "views/Details/PaymentLead.jsx";
import PaymentRepayment from "views/Installment/PaymentRepayment.jsx";
import WalletHistory from "views/Installment/WalletHistory.jsx";

// const authToken = localStorage.getItem('AccessToken');
// const userId = localStorage.getItem('user_id');
// const currentPath = window.location.pathname;

// // Redirect only if missing auth AND not already on /login
// if ((!authToken || !userId) && currentPath !== '/login') {
//   window.location.href = '/login';
// }

if (process.env.NODE_ENV === 'development') {
  console.log('Running in development mode');
} else if (process.env.NODE_ENV === 'production') {
  console.log('Running in production mode');
}
const privilegeList = getPrivilegeList();


var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-chart-pie-35 text-primary",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/lead-list",
    name: "Lead list",
    icon: "ni ni-tv-2 text-primary",
    component: <LeadList />,
    layout: "/admin",
  },
  {
    path: "/loan-list",
    name: "Loan",
    icon: "ni ni-money-coins text-orange",
    component: (
      <EntityList
        title="Loans"
        endpoint={API_URL.REPORTING_LOAN_SUMMARY}
        dateFilter
        lspFilter
        statusFilter={[
          { label: "Pending", value: 24 },
          { label: "Approved", value: 25 },
          { label: "Disbursed", value: 26 },
          { label: "Closed", value: 28 },
          { label: "Rejected", value: 19 },
        ]}
        idFilter
        idFilters={[
          { label: "Loan ID", param: "loanId" },
          { label: "Lead ID", param: "leadId" },
          { label: "Application ID", param: "applicationId" },
          { label: "Customer ID", param: "customerId" },
        ]}
        columns={[
          "loan_code",
          "customer_code",
          "borrower_name",
          "fintech_name",
          "loan_type",
          "loan_amount",
          "disbursed_amount",
          "status",
        ]}
        viewLink={(r) =>
          r.customer_id && r.lead_id
            ? `/customer/loans/${r.customer_id}/${r.lead_id}`
            : null
        }
      />
    ),
    layout: "/admin",
  },
  {
    path: "/customer-list",
    name: "Customer",
    icon: "ni ni-single-02 text-info",
    component: (
      <EntityList
        title="Customers"
        endpoint={API_URL.REPORTING_CUSTOMER_SUMMARY}
        dateFilter
        lspFilter
        idFilter
        idFilters={[
          { label: "PAN", param: "panNumber" },
          { label: "Mobile Number", param: "mobileNumber" },
          { label: "Customer ID", param: "customerId" },
          { label: "Lead ID", param: "leadId" },
          { label: "Loan ID", param: "loanId" },
        ]}
        columns={[
          "customer_code",
          "lead_code",
          "loan_code",
          "borrower_name",
          "fintech_name",
          "employment_type",
          "pan_number",
          "create_date",
        ]}
      />
    ),
    layout: "/admin",
  },
  {
    path: "/repayment",
    name: "Repayment",
    icon: "ni ni-credit-card text-green",
    component: <RepaymentSchedule />,
    layout: "/admin",
  },
  {
    path: "/collection",
    name: "Collection",
    icon: "ni ni-chart-bar-32 text-red",
    component: (
      <EntityList
        title="Collections"
        endpoint={API_URL.REPORTING_PAYMENT_SUMMARY}
        summaryEndpoint={API_URL.REPORTING_COLLECTION_SUMMARY}
        dateFilter
        defaultRangeDays={0}
        schemeFilter
        idFilter
        idFilters={[
          { label: "Customer ID", param: "customerId" },
          { label: "Loan ID", param: "loanId" },
          { label: "Payment ID", param: "paymentId" },
          { label: "Txn ID", param: "tranId" },
        ]}
        lspFilter
        columns={[
          "payment_id",
          "customer_code",
          "borrower_name",
          "loan_code",
          "total_payment_amount",
          "total_principal_settled",
          "total_interest_settled",
          "total_settled_amount",
          "tran_date",
        ]}
      />
    ),
    layout: "/admin",
  },
  {
    path: "/payment-reco",
    name: "Reconciliation",
    icon: "ni ni-money-coins text-green",
    component: <PaymentReco />,
    layout: "/admin",
  },
  {
    path: "/loan-reco",
    name: "Loan Reconciliation",
    icon: "ni ni-money-coins text-green",
    component: <LoanReco />,
    layout: "/admin",
  },
  {
    path: "/training",
    name: "Training",
    icon: "ni ni-books text-primary",
    component: <Training />,
    layout: "/admin",
  },
  {
    path: "/reporting/portfolio",
    name: "Portfolio Report",
    icon: "ni ni-chart-bar-32 text-primary",
    component: <PortfolioReport />,
    layout: "/admin",
  },
  {
    path: "/enrichment-retry",
    name: "Enrichment Retry",
    icon: "ni ni-atom text-blue",
    component: <EnrichmentRetry />,
    layout: "/admin",
  },
  {
    path: "/personal-loan-upload",
    name: "Personal Loan Upload",
    icon: "ni ni-cloud-upload-96 text-green",
    component: <PersonalLoanBulkUpload />,
    layout: "/admin",
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: "ni ni-chart-bar-32 text-info",
    component: <Analytics />,
    layout: "/admin",
  },
  {
    path: "/lsp-list",
    name: "LSP list",
    icon: "ni ni-tv-2 text-primary",
    component: <LSPList />,
    layout: "/admin",
  },

  
{
  path: "/template",
  name: "Template",
  icon: "ni ni-collection text-orange",
  component: <Template />,
  layout: "/admin",
   
},


  {
    path: "/privilege",
    name: "LSP list",
    icon: "ni ni-tv-2 text-primary",
    component: <Privilege />,
    layout: "/admin",
  },
  {
    path: "/admin-panel",
    name: "admin-panel",
    icon: "ni ni-tv-2 text-primary",
    component: <UserManagement />,
    layout: "/admin",
  },
  {
    path: "/bre-panel",
    name: "bre-panel",
    icon: "ni ni-tv-2 text-primary",
    component: <BrePanel />,
    layout: "/admin",
  },
   {
    path: "/payout-request",
    name: "payout-request",
    icon: "ni ni-tv-2 text-primary",
    component: <PayOutRequest />,
    layout: "/admin",
  },

    {
    path: "/lsp-update",
    name: "lsp-update",
    icon: "ni ni-tv-2 text-primary",
    // component: <PayOutRequest />,
    component: <UpdateLspList />,
    layout: "/admin",
  },
  {

    ...(privilegeList?.detailShow
      ?
       {
        path: "/detail/:cid/:lid",
        name: "Customer",
        icon: "fa-regular fa-user",
        component: <CustomerDetail />,
        layout: "/customer",
      }
    : [])
  },
  {
     ...(privilegeList?.loanTabShow
      ? {
    path: "/loans/:cid/:lid",
    name: "Leads",
    icon: "fa-solid fa-money-bill-transfer",
    component: <Loans />,
    layout: "/customer",
     }
    : [])
  },
  {
      // Comments tab hidden from the customer nav.
      ...(false && privilegeList?.commentTabShow
      ? {
    path: "/comments/:cid/:lid",
    name: "Comments",
    icon: "fa-regular fa-comment",
    component: <Comments />,
    layout: "/customer",
    }
    : [])
  },
  {
      ...(privilegeList?.foirTabShow
      ? {
    path: "/foir/:cid/:lid",
    name: "Foir",
    icon: "fa-solid fa-coins",
    component: <Foir />,
    layout: "/customer",
    }
    : [])
  },
  {
      ...(privilegeList?.creditTabShow
      ? {
    path: "/credit/:cid/:lid",
    name: "Credit",
    icon: "fa-solid fa-building-columns",
    component: <Credit />,
    layout: "/customer",
    }
    : [])
  },
  {
      // Nav redirects to the Lead card's Installment tab (the standalone section stays hidden).
      ...(privilegeList?.installmentTabShow
      ? {
    path: "/Installment/:cid/:lid",
    name: "Installment & Collection",
    icon: "fa-solid fa-list",
    component: <Installment />,
    layout: "/customer",
    }
    : [])
  },
  
  {
     // Documents placed just above Legal in the customer nav.
     ...(privilegeList?.documentTabShow
      ? {
    path: "/documents/:cid/:lid",
    name: "Documents",
    icon: "fa-regular fa-folder",
    component: <CustomerDocuments />,
    layout: "/customer",
    }
    : [])
  },
  {
     ...(privilegeList?.legalTabShow
      ? {
    path: "/legal/:cid/:lid",
    name: "Legal",
    icon: "fa-solid fa-file-contract",
    component: <Legal />,
    layout: "/customer",
    }
    : [])
  },
  {
     ...(privilegeList?.communicationLogTabShow
      ? {
    path: "/communication/:cid/:lid",
    name: "Communication Log",
    icon: "fa-regular fa-message",
    component: <Communication />,
    layout: "/customer",
     }
    : [])
  },
// {
//   ...(privilegeList?.communicationLogTabShow
//     ? {
//         path: "/lsp-provided-json/:cid/:lid",
//         name: "JSON",
//         icon: "fa-solid fa-code",
//         component: <LspProvidedJson />,
//         layout: "/customer",
//       }
//     : [])
// },

{
path: "/lsp-provided-json/:cid/:lid?", // '?' makes lid optional
    name: "JSON",
    icon: "fa-solid fa-code",
    component: <LspProvidedJson />,
    layout: "/customer",
},

  {
    // ...(privilegeList?.creditTabShow
    // ? {
    path: "/engien/:cid/:lid",
    name: "Rule Engien",
    icon: "fa-solid fa-flask",
    component: <Communication />,
    layout: "/rule",
  // }
  // : [])
  },
  {
      path: "/webhook",
      name: "webhook",
      icon: "fa-solid fa-flask",
      component: <Webhook />,
      layout: "",
  },
  {
    path: "/Agreement/LoanAgreement",
    name: "Loan Agreement",
    icon: "ni ni-single-copy-04 text-primary",
    component: <LoanAgreement />,
    layout: "",
  },
 {
  path: "/reporting",
  name: "Reporting",
  icon: "ni ni-chart-bar-32 text-success", // you can change icon as needed
  component: <Reporting />,
  layout: "/admin",
},
{
  path: "/merchant-reports",
  name: "Reports",
  icon: "ni ni-shop text-info", // standalone reporting service
  component: <MerchantReports />,
  layout: "/admin",
},
{
  path: "/loan-documents",
  name: "Loan Statement / Card",
  icon: "ni ni-single-copy-04 text-info", // SOA + loan card (reporting service)
  component: <LoanDocuments />,
  layout: "/admin",
},
{
  path: "/overdue-report/emi",
  name: "Overdue Reporting",
  icon: "ni ni-time-alarm text-danger",
  component: <OverdueReporting />,
  layout: "/admin",
},

{
  path: "/fintech-Wallet/",
  name: "Fintech Wallet",
  icon: "fa-solid fa-building-columns",
  component: <FintechWallet />,
  layout: "/admin",
},
{
  path: "/lsp-balance",
  name: "LSP Balance",
  icon: "ni ni-money-coins",
  component: <LspBalance />,
  layout: "/admin",
},

// Inside routes.js
{
  path: "/full-view/:cid/:lid",
  name: "",
  icon: "",
  component: <MasterScroll />,
  layout: "/customer",
},

// ---- Payment lead layout (customers with payment_tran = true) ----
// The sidebar for /payment is built from these entries (order = tab order).
{
  path: "/detail/:cid/:lid",
  name: "Customer",
  icon: "fa-regular fa-user",
  component: <CustomerDetail />,
  layout: "/payment",
},
{
  path: "/loans/:cid/:lid",
  name: "Leads & Credit",
  icon: "fa-solid fa-money-bill-transfer",
  component: <LeadCredit />,
  layout: "/payment",
},
{
  path: "/credit/:cid/:lid",
  name: "Credit",
  icon: "fa-solid fa-chart-line",
  component: <Credit />,
  layout: "/payment",
},
{
  path: "/documents/:cid/:lid",
  name: "Documents",
  icon: "fa-regular fa-folder",
  component: <CustomerDocuments />,
  layout: "/payment",
  display: false,
},
{
  path: "/installment/:cid/:lid",
  name: "Installment & Collection",
  icon: "fa-solid fa-list",
  component: <PaymentRepayment />,
  layout: "/payment",
},
{
  path: "/credit-history/:cid/:lid",
  name: "Credit History",
  icon: "fa-solid fa-wallet",
  component: <WalletHistory />,
  layout: "/payment",
  display: false,
},
{
  path: "/legal/:cid/:lid",
  name: "Legal",
  icon: "fa-solid fa-file-contract",
  component: <Legal />,
  layout: "/payment",
},
{
  path: "/lsp-provided-json/:cid/:lid?",
  name: "JSON",
  icon: "fa-solid fa-code",
  component: <LspProvidedJson />,
  layout: "/payment",
  display: false, // JSON hidden from the payment view nav/section
},
{
  path: "/full-view/:cid/:lid",
  name: "",
  icon: "",
  component: <PaymentLead />,
  layout: "/payment",
},


];
export default routes;
